<ng-template #changesModal let-modal>
	
    <div class="modal-header row">
        <div class="col-11 m-0 p-0 text-left">
            <h4 class="modal-title" id="modal-title">Counts Changed</h4>
            <hr/>
            <h6 class="font-weight-lighter" *ngIf="autosave">Auto-save has been toggled on - store or discard in progress edits before proceeding</h6>
        </div>
        <div class="col-1 m-0 p-0 text-center vertical-align-middle">
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
        </div>
	</div>

	<div class="modal-body">
        <table class="table w-100 m-0 table-striped table-fixed table-bordered" style="max-height: 70vh; overflow: scroll">
            <thead>
                <tr>
                    <th>BIN</th>
                    <th>STOCKID</th>
                    <th>DESCRIPTION</th>
                    <th class="text-center">QOH</th>
                    <th class="text-center">PREVIOUS</th>
                    <th class="text-center">BY?</th>
                    <th class="text-center">UPDATED</th>
                    <th></th>
                </tr>
                
            </thead>
            <tbody *ngIf="itemsToreview.length">
                <tr *ngFor="let item of itemsToreview; let i = index">
                    <td>{{item.bin}}</td>
                    <td>{{item.stockid}}</td>
                    <td>{{item.description}}</td>
                    <td class="text-center">{{item.qoh}}</td>
                    <td class="text-center">{{item.originalcounted ?? '-'}}</td>
                    <td class="text-center">
                        <ng-container *ngIf="item.hasbeencounted">
                            {{item.user}} @ {{item.time}}
                        </ng-container>
                        <ng-container *ngIf="!item.hasbeencounted"> - </ng-container>
                    </td>
                    <td class="text-center">{{item.counted}}</td>
                    <td class="text-center">
                        <button mat-mini-fab (click)="resetCount(item); itemsToreview.splice(i, 1);">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
            <tbody *ngIf="!itemsToreview.length">
                {{modalService.dismissAll()}}
            </tbody>
        </table>
    </div>

    <div class="modal-footer">
        <div class="row m-0 p-0 w-100 justify-content-around">
            <button *ngIf="!autosave" mat-stroked-button (click)="modalService.dismissAll()">Close</button>
            <button *ngIf="autosave" mat-stroked-button class="text-danger" (click)="discardBatchEdits()">Discard edits</button>
            <button mat-stroked-button (click)="saveFreeCounts(itemsToreview)">Store Counts</button>
        </div>
    </div>
</ng-template>

<div class="main-content">

     <!-- Scanner Input Display -->
     <div class="container-fluid tp-box" [@flipState]="flip">
        <div class="tp-box__side tp-box__front" id="frontside" [ngClass]="flip != 'active' ? '' : 'd-none'">
            <div class="m-0 p-0 w-100">
                <div class="row w-100 m-0 p-0">
                    <div class="row m-0 p-0 w-100" [ngClass]="{'col-10': !isMobile, 'col-12': isMobile}">
                        <form [formGroup]="sheetForm" *ngIf="sheetForm" class="w-100 m-0 p-0">
                            <div class="row m-0 p-0 w-100">
                                <div class="row w-100 m-0 p-0 justify-content-end" *ngIf="!counting_items.data?.length && !unfiltered_all_counts">
                                    <span class="warning-span w-100 text-right">
                                        <ng-container *ngIf="!fetching">
                                            No counts Loaded &nbsp;<mat-icon class="orange-icon">warning</mat-icon>
                                        </ng-container>
                                        <ng-container *ngIf="fetching">
                                            Loading...
                                        </ng-container>
                                    </span>
                                </div>
                        
                                <mat-expansion-panel hideToggle [expanded]="filterPanelViewable" (opened)="filterview = true" (closed)="filterview = false" class="filter-row mb-1 w-100" [ngClass]="{'warning-span-border': !counting_items.data?.length, 'default-span-border mat-elevation-z1': counting_items.data?.length}" id="filter-expansion-panel">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                        <mat-icon *ngIf="!filterview">chevron_right</mat-icon>
                                        <mat-icon *ngIf="filterview">keyboard_arrow_down</mat-icon>
                                        Filters
                                        
                                        </mat-panel-title>
                                        <mat-panel-description class=" w-100 m-0 p-0 d-flex justify-content-end" *ngIf="!fetching && counting_items.data?.length">
                                            <span *ngIf="mfgnames && filters.vendor != ''" class="filter" [ngClass]="{'active rot-1 mat-elevation-z1': filters.vendor != ''}">{{filters.vendor}}</span>
                                            <span *ngIf="categorynames && filters.category != ''" class="filter" [ngClass]="{'active rot-2 mat-elevation-z1': filters.category != ''}">{{filters.category}}</span>
                                            <span *ngIf="productlinenames && filters.productline != ''" class="filter" [ngClass]="{'active rot-3 mat-elevation-z1': filters.productline != ''}">{{filters.productline}}</span>
                                            <span class="filter" [ngClass]="{'active rot-4 mat-elevation-z1': sheetForm.get('location').value != ''}">LOC {{sheetForm.get('location').value}} </span>
                                            <ng-container *ngIf="fetching">
                                                <svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                                    <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                                                </svg>
                                            </ng-container>
                                        </mat-panel-description>
                                    </mat-expansion-panel-header>
                                    
                                    <div class="row">
                                        <div class="col-md-3">
                                            <mat-form-field appearance="outline">
                                                <mat-label>Warehouse</mat-label>
                                                <mat-select formControlName="location">
                                                    <mat-option *ngFor="let loc of locations" [value]="loc.loccode">
                                                        {{ loc.locationname }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-3">
                                            <mat-form-field appearance="fill" *ngIf="mfgs">
                                                <mat-label>Brand</mat-label>
                                                <mat-select formControlName="vendor">
                                                    <mat-option *ngFor="let i of mfgs" [value]="i.value">
                                                        {{i.view}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                            
                                        </div>
                                        <div class="col-md-3">
                                            <mat-form-field appearance="fill" *ngIf="categories">
                                                <mat-label>Category</mat-label>
                                                <mat-select formControlName="category">
                                                    <mat-option *ngFor="let i of categories" [value]="i.value">
                                                        {{i.view}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-3">
                                            <mat-form-field appearance="fill" *ngIf="productlines">
                                                <mat-label>Product Lines</mat-label>
                                                <mat-select formControlName="lineid">
                                                    <mat-option *ngFor="let i of productlines" [value]="i.value">
                                                        {{i.view}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-12 justify-content-between d-flex">
                                            <button mat-raised-button color="accent" (click)="clearFilters()">Clear Filters</button>
                                            <button class="" mat-raised-button color="primary" (click)="initialLoad('clicked')" [disabled]="fetching">
                                                <ng-container *ngIf="!fetching">
                                                    Create/Load Sheets
                                                </ng-container>
                                            </button>
                                        </div>
                                    </div>
                                    </mat-expansion-panel>
                            </div>
                        
                        <div class="row">
                            <div class="col-8">
                                <div class="alert alert-info " *ngIf="!counting_items"> Select a warehouse and inventory items to start.
                                    Then create and load the sheets to count. Use the PDF to produce stock count sheets if needed.</div>
                            </div>       
                        </div>
                    </form>
                    </div>

                    <div class="col-2 text-center" [ngClass]="!isMobile ? '' : 'd-none'">
                        <div class="row w-100 m-0 p-0 paginator-index mat-elevation-z1" >
                            <ng-container *ngIf="counting_items?.data?.length">
                                <div class="col-12 m-0 p-0 text-center" style="background: #e5e5e5;">
                                    <span><mat-icon style="position: absolute; left: 0; scale: .75; color: rgb(179, 179, 179)">visibility</mat-icon> COUNTS</span>
                                </div>
                                <div class="col-6 m-0 p-0 border-right" style="background: white;">
                                    {{paginator.pageSize * (paginator.pageIndex)}}-{{paginator.pageSize * (paginator.pageIndex+1) >= paginator.length ? paginator.length : paginator.pageSize * (paginator.pageIndex+1)}}
                                </div>
                                <div class="col-6 m-0 p-0" style="background: white;">{{paginator.length}}</div>
                            </ng-container>
                                                        
                            <svg *ngIf="fetching" class="spinner m-auto" width="24px" height="24px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                            </svg>

                        </div>
                        <br class="d-block h-0 w-100"/>
                        <mat-paginator id="paginator" #paginatorTop [hidePageSize]="true" [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault"></mat-paginator>
                    </div>
                </div>
                <div class="w-100 cc-t">
                    <div #count_table class="table count-table" *ngIf="counting_items">
                        <span id="toptable"></span>
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr class="m-0 p-0 noprint">
                                    <td colspan="8" class="m-0 p-0">
                                        <div class="w-100 m-0 p-0 d-flex justify-content-center" id="scan-box">
                    
                                            <div class="scanner-input-display w-100 m-0 p-0" [class.scanning]="isScanning" [class.error]="scanStatus === 'error'" [class.warning]="scanStatus === 'warning'" [class.processing]="scanStatus === 'processing'" [class.manager-mode]="isManagerMode">
                                                <div class="scanner-status" *ngIf="!isMobile">
                                                    <mat-icon class="scanner-icon">
                                                        {{ scanStatus === 'error' ? 'error' : 
                                                        scanStatus === 'warning' ? 'warning' : 
                                                        scanStatus === 'processing' ? 'hourglass_empty' : 
                                                        isScanning ? 'scanner' : (isSearchMode ? 'search' : 'keyboard') }}
                                                    </mat-icon>
                                                    <span class="scanner-label">
                                                        {{ statusMessage || (isScanning ? 'Scanning...' : (isSearchMode ? 'Ready to search' : 'Ready to scan')) }}
                                                        <span class="mode-indicator" (click)="changeCountMode(CURRENT_MODE)" [ngClass]="sendToggle.value ? 'scan-out' : 'scan-in'" *ngIf="!isScanning">{{ CURRENT_MODE + ' MODE' }}</span>
                                                        <span class="mode-indicator" (click)="toggleAutoSave()" [matTooltip]=" autosave ? 'Disable to save counts in batches' : 'Enable to save counts instantly'">
                                                            <i *ngIf="!autosave" class="fa fa-square-o" aria-hidden="true"></i>
                                                            <i *ngIf="autosave" class="fa fa-check-square-o text-success" aria-hidden="true"></i>
                                                            AUTO SAVE</span>
                                                    </span>
                                                    
                                                    <button mat-raised-button *ngIf="addToBinOption" (click)="addItemToBin(false)">Cancel Add</button>
                                                    <button mat-raised-button *ngIf="addToBinOption" (click)="addItemToBin(true)">Add to bin?</button>
                                                </div>
                                        
                                                <!-- Last Scan Time Display -->
                                                <div class="last-scan-time" *ngIf="lastScanTime && !isMobile">
                                                <mat-icon>schedule</mat-icon>
                                                <span>Last scan: {{ getLastScanTimeDisplay() }}</span>
                                                </div>
                                        
                                                <!-- Scanner Mode Input -->
                                                <div class="scanner-input" *ngIf="!isSearchMode" (click)="onMobileScannerInputTap()" [class.mobile-tappable]="isMobile">
                                                    <ng-container *ngIf="isMobile">
                                                        <div class="row w-100 m-0 p-0 ">
                                                            <span class="input-label">Captured:</span>
                                                            <span class="input-value">{{ keyBuffer || statusMessage }}</span>
                                                            <button mat-raised-button *ngIf="addToBinOption" (click)="$event.preventDefault(); $event.stopPropagation(); addItemToBin(true)">Add to bin</button>
                                                        </div>
                                                    </ng-container>
                                                    <ng-container *ngIf="!isMobile">
                                                        <span class="input-label">Captured:</span>
                                                    <span class="input-value">{{ keyBuffer || (selectedBin ? 'Waiting for item scan...' : 'Waiting for bin scan...') }}</span>
                                                    </ng-container>
                                                </div>
                                            
                                        
                                                <!-- Search Mode Input -->
                                                <div class="search-input" *ngIf="isSearchMode">
                                                <div class="custom-search-field">
                                                    <div class="search-input-container">
                                                    <input type="text" [formControl]="searchInput" (keyup.enter)="$event.preventDefault(); $event.stopPropagation(); performSearch()" placeholder="Enter SKU, barcode, or description" class="search-input-field" #searchInputRef>
                                                    <button type="button" (click)="performSearch()" class="search-button">
                                                        <mat-icon>search</mat-icon>
                                                    </button>
                                                    </div>
                                                </div>
                                                <!-- Mobile back to scanner button -->
                                                <div class="mobile-search-controls" *ngIf="isMobile">
                                                    <button mat-raised-button color="primary" (click)="toggleSearchMode()" class="back-to-scanner-btn">
                                                    <span>Back to Scanner</span>
                                                    </button>
                                                </div>
                                                </div>
                                            </div>
                                        
                                    
                                            <!-- Hidden input field for keyboard prevention -->
                                            <input #hiddenScanInput type="text" [formControl]="hiddenScanControl" class="hidden-scan-input" (focus)="onHiddenInputFocus()" (keydown)="onHiddenInputKeyDown($event)" autocomplete="off" tabindex="-1">
                                        </div>
                                    </td>
                                </tr>
                                <tr class="tr-sticky-border mat-elavation-z1">
                                    <td class="text-center" *ngIf="!isMobile">LINE</td>
                                    <td class="text-center" [ngClass]="selectedBin != '' ? 'background-selected':''">
                                        <ng-container *ngIf="isMobile">BIN</ng-container>
                                        <ng-container *ngIf="!isMobile">
                                            <button class="w-100 m-0 p-0 bin-select-button" mat-stroked-button color="primary" *ngIf="!selectingBin" (click)="binSelectionMode()">Bin [&nbsp;{{allbins && selectedBin == "" ? 'ALL': (selectedBin == "" && !allbins) ? 'EMPTY' : selectedBin }}&nbsp;]</button>
                                            <mat-form-field *ngIf="selectingBin">
                                                <input type="text" matInput id="bininput" #trigger="matAutocompleteTrigger" [formControl]="myControl" [matAutocomplete]="auto">
                                                <button mat-icon-button matSuffix tabindex="-1"> 
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                                <mat-autocomplete #auto="matAutocomplete" (closed)="selectBin()">
                                                    <mat-option [value]="'ALL'">ALL</mat-option>
                                                    <mat-option *ngFor="let option of binsFiltered | async" [value]="option">
                                                        {{option}}
                                                    </mat-option>
                                                  </mat-autocomplete>
                                            </mat-form-field>
                                        </ng-container>
                                    </td>
                                    <td class="text-center">ITEM</td>
                                    <td class="text-center" *ngIf="!isMobile">DESCRIPTION</td>
                                    <td class="text-center" *ngIf="!isMobile">VENDOR</td>
                                    <td class="text-center" *ngIf="!isMobile">COUNTED BY</td>
                                    <td class="text-center">QOH</td>
                                    <td class="noprint text-center">COUNT</td>
                                    <td class="noshow text-center">COUNT</td>
                                </tr>
                            </thead>
                            <tbody [ngClass]="CURRENT_MODE == 'BIN' && selectedBin == '' && isMobile && !isSearchMode ? 'opa-low' : ''">
                                <ng-container *ngFor="let item of dataObs | async ;">
                                    <tr id="{{item.stockid}}" [ngClass]="{'selected-item': currentItem && currentItem.stockid == item.stockid && ((item.bin == currentItem.bin || selectedBin == item.bin) || (CURRENT_MODE == 'BIN' && selectedBin == item.bin)), 'has-been-counted': item.hasbeencounted, 'haschanged': itemsToSave[item.bin + item.stockid]}" *ngIf="!isMobile">
                                        <td>
                                            <div class="row w-100 m-0 p-0 lineno-td text-center">
                                                <mat-icon class="d-none text-center mat-elevation-z1" (click)="resetCount(item)">undo</mat-icon>
                                                <span class="text-center">{{ item.line ?? item.fakeline }}</span>
                                            </div>
                                        </td>
                                        <td class="text-center col-1" [ngClass]="selectedBin == item.bin && selectedBin != '' ? 'background-selected': ''"> 
                                            <span>{{ item.bin }}</span>
                                        </td>

                                        <td class="text-left desc-row col-2"> 
                                            <b>{{ item.partno }}</b>
                                        </td>
                                        <td class="text-left col-3 font-weight-lighter">
                                            {{ item.description }}
                                        </td>
                                        <td class="text-left italics">
                                            {{item.vendor}}
                                        </td>
                                        <td [ngClass]="{'text-left': item.hasbeencounted, 'text-center': !item.hasbeencounted}">
                                            <ng-container *ngIf="item.hasbeencounted">
                                                {{item.user}} @ {{item.time}}
                                            </ng-container>
                                            <ng-container *ngIf="!item.hasbeencounted">-</ng-container>
                                        </td>
                                        
                                        <td class="text-center col-1"> {{ item.qoh }}</td>
                                        <td class="text-center noprint col-1">
                                            <input matInput class="form-control text-center count-control text-black" [ngClass]="{'count-danger': item.hasbeencounted && item.counted < item.qoh, 'count-warning': item.hasbeencounted && item.counted > item.qoh, 'count-success': item.hasbeencounted && item.counted == item.qoh}" type="text" [(value)]="item.counted" pattern="[0-9]*" inputmode="numeric" (focus)="selectInput(item)" (keydown)="preventTab($event, item)" (input)="debounceQty($event, item)" id="{{item.bin}}{{item.stockid}}-input">
                                            <svg *ngIf="item.saving" class="spinner count-saving" width="25px" height="25px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                                <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                                            </svg>
                                        </td>
                                        <td class="text-center noshow">
                                            <span class="mt-3">_________</span>
                                        </td>
                                    </tr>
                                    <tr id="{{item.stockid}}" [ngClass]="{'selected-item': currentItem && currentItem.stockid == item.stockid, 'has-been-counted': item.hasbeencounted}" *ngIf="isMobile" (click)="editingMode ? currentItem = item : ''">
                                        <!-- <td class="text-center">
                                            {{ item.line }}
                                        </td> -->
                                        <td class="text-center" [ngClass]="selectedBin == item.bin ? 'background-selected': ''"> 
                                            <span>{{ item.bin }}</span>
                                        </td>
                                        <td class="text-left desc-row mobile"> 
                                            <span><b>{{ item.partno }}</b></span>
                                            <ng-container>
                                                &nbsp;<span class='font-weight-lighter'> {{ item.description }}</span>
                                            </ng-container>
                                            <ng-container *ngIf="item?.user?.length && item?.time?.length">
                                                <br/>
                                                <span>{{item.user}} @ {{item.time}}</span>
                                            </ng-container>
                                            
                                        </td>
                                        <td class="text-center"> {{ item.qoh}}</td>
                                        <td class="text-center noprint">
                                            <input class="form-control text-center count-control mat-elevation-z4" [ngClass]="{'count-danger': item.hasbeencounted && item.counted < item.qoh, 'count-warning': item.hasbeencounted && item.counted > item.qoh, 'count-success': item.hasbeencounted && item.counted == item.qoh}" type="text" [(value)]="item.counted" pattern="[0-9]*" inputmode="numeric" (input)="!item?.time?.length && !item?.user?.length ? setQty($event, item) : ''">
                                        </td>
                                        <td class="text-center noshow">
                                            <span class="mt-3">_________</span>
                                        </td>
                                    </tr>
                                </ng-container>
                                <tr *ngIf="fetching">
                                    <td class="text-center" colspan="4" *ngIf="isMobile">
                                        <svg class="spinner" width="20px" height="20px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                                        </svg>
                                    </td>
                                    <td class="text-center" colspan="8" *ngIf="!isMobile">
                                        <svg class="spinner" width="20px" height="20px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                                        </svg>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        

                    </div>
                </div>

            </div>
        </div>

        <div class="tp-box__side tp-box__back" [ngClass]="flip != 'inactive' ? '' : 'd-none'">
            <ng-container *ngIf="sheetForm">
                <app-review-counts #reviewComponent [filters]="sheetForm.value" (complete)="resetSheets()" *ngIf="sheetForm" [flip]="flip"></app-review-counts>
            </ng-container>
        </div>
    </div>

    <nav class="navbar fixed-bottom navbar-dark justify-content-right" id="bottom-nav" [ngClass]="isMobile ? 'bg-nav': 'bg-nav-desktop'">
        <div *ngIf="isMobile && selectedBin" class="w-100 p-1">
            <div class="w-100 row m-auto">
                <span class="m-0 p-0 text-center" style="width:100%; position:absolute; left:0; top:-10px" *ngIf="bincounted && !editingMode">
                    <span class="bin-counted-label">BIN HAS BEEN COUNTED | {{lastbinupdate.user}} @ {{lastbinupdate.time}}</span>
                </span>
                <div *ngIf="!editingMode" class="row m-auto justify-content-between mobile-bottom mat-elevation-z4">
                    <button *ngIf="!editingMode" mat-stroked-button [matMenuTriggerFor]="menu"> {{selectedBin}} </button>
                    <mat-menu #menu="matMenu" class="m-0 p-0">
                        <button mat-menu-item (click)="resetBinSelection(); initialLoad()">Discard edits & exit bin</button>
                    </mat-menu>
                    <div class="row m-auto" *ngIf="currentItem">
                        <mat-icon (click)="editingMode = !editingMode" [ngClass]="">edit</mat-icon>
                    </div>
                    <button *ngIf="!editingMode" mat-stroked-button color="primary" (click)="completeBinSelection()">Save</button>
                </div>
                <div class="" [ngClass]="{'editmenu-h' : !editingMode, 'editmenu row m-auto justify-content-between mobile-bottom mat-elevation-z4': editingMode}">
                    <mat-icon (click)="editingMode = !editingMode">highlight_off</mat-icon>
                    <ng-container *ngIf="currentItem">
                        <button class="edit-control" mat-stroked-button (click)="updateCurrentCount(-1, currentItem)">-</button>
                        <span style="max-width: 25%;">
                            {{currentItem.stockid}} &nbsp; (<b>{{currentItem.counted}}</b>)
                        </span>
                        <button class="edit-control" mat-stroked-button (click)="updateCurrentCount(1,currentItem)">+</button>
                    </ng-container>
                </div>
            </div>
        </div>

        <div *ngIf="!isMobile " class="w-100 p-1">
            <div class="desktop-bottom row m-auto justify-content-end">                
                <span>
                    <button class="nav-item btn btn-danger" (click)="pdfLink()" *ngIf="flip == 'inactive'">
                        <ng-container *ngIf="!sheetsPrinting">Print Count Sheets</ng-container>  
                        <ng-container *ngIf="sheetsPrinting">
                            Printing sheets...
                            <svg class="spinner" width="14px" height="14px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                            </svg>
                        </ng-container>
                        
                    </button>

                    <button type="button" id="button-back" class="nav-item btn btn-warning" (click)="itemsToSaveCount() ? completeEditedItems() : toggleFlip()">
                        <span *ngIf="flip == 'inactive'">Review & Finalize Counts
                            <ng-container *ngIf="itemsToSaveCount()">
                                <mat-icon>warning</mat-icon>
                            </ng-container>
                        </span>
                        <span *ngIf="flip == 'active'"><i class="fa fa-arrow-left"></i>&nbsp;Back to Counting</span>
                    </button>
                    <button *ngIf="flip == 'active'" type="button" id="button-back" class="nav-item btn btn-success" (click)="closeCounts();">
                        <span>Finalize Counts</span>
                    </button>
                </span>

            </div>
        </div>
    </nav>

</div>




